import { gql } from '@apollo/client';

export type StudySetting = {
  duration: number;
  preEventTime: number;
  postEventTime: number;
  bradycardiaThreshold: number;
  tachycardiaThreshold: number;
  pauseLevel: number;
  pauseDetection: boolean;
  afibDetection: boolean;
  diagnosticLead: string;
};

const StudySettingFragment = gql`
  fragment StudySettingFragment on StudySetting {
    duration
    preEventTime
    postEventTime
    bradycardiaThreshold
    tachycardiaThreshold
    pauseLevel
    pauseDetection
    afibDetection
    diagnosticLead
  }
`;

export default StudySettingFragment;
